var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc guest center"},[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.translator.reserva_finalitzada1))]),_c('h5',{staticClass:"text-center mt-3"},[_vm._v(_vm._s(_vm.translator.reserva_finalitzada2))])])}
var staticRenderFns = []

export { render, staticRenderFns }